var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28961 16C13.8368 16 17.9648 9.84381 17.9648 4.50514C17.9648 4.33031 17.9648 4.15624 17.9528 3.98294C18.7559 3.41102 19.4491 2.70295 20 1.89177C19.2511 2.21848 18.4566 2.43269 17.6432 2.52738C18.4996 2.02264 19.141 1.22815 19.4472 0.292828C18.6418 0.763375 17.7605 1.09505 16.8416 1.27346C16.0657 0.461163 14.9821 0 13.8497 0C11.5965 0 9.74246 1.82542 9.74246 4.04375C9.74246 4.3515 9.77816 4.65829 9.84879 4.95804C6.55121 4.79532 3.47457 3.25964 1.39199 0.737069C0.309023 2.57257 0.869375 4.95127 2.66238 6.13004C2.00945 6.111 1.37055 5.93755 0.8 5.62438V5.67557C0.800547 7.59137 2.18465 9.25654 4.09199 9.63586C3.48793 9.79804 2.85398 9.82173 2.23922 9.70516C2.77543 11.3468 4.32168 12.4784 6.07281 12.5108C4.62008 13.6348 2.82449 14.2454 0.976797 14.2436C0.650313 14.243 0.324141 14.2235 0 14.1853C1.87633 15.3708 4.06016 15.9998 6.28961 15.9968",
    fill: "#A2A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGray);
export default __webpack_public_path__ + "static/media/twitterGray.538ef2285667565904baa9e683b03b23.svg";
export { ForwardRef as ReactComponent };